// @ts-nocheck
import styled from "styled-components";

export const Wrapper = styled.div`
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
`;
